import Pagination from '../Pagination'
import Sort from '../SortReq'

export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    title: other.title || null,
    types: other.types || [],
    statuses: other.statuses || [],
    priorities: other.priorities || [],
    createdBy: other.createdBy || null,
    assignedTo: other.assignedTo || null,
    creationTimeStart: other.creationTimeStart || null,
    creationTimeEnd: other.creationTimeEnd || null,
    search: other.search || null,
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort(),
  }
}
